<!-- <div class="debug"></div>
    <p>Player id = {{ playerId }}</p>
</div> -->

<app-player-details [playerBasic]="playerBasic$ | async"></app-player-details>